import Abstract from "../../abstract-view/abstract.js";

import {
  PROMOCODE_INPUT_NAME
} from "../const.js";

import {
  APPLIED_TEXT
} from "../lexicon.js";

export default class CartPromocodeForm extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._inputElement = null;
    this._inputParentElement = null;
    this._buttonElement = null;

    this._defaultButtonText = null;

    this._submitHandler = this._submitHandler.bind(this);
    this._inputHandler = this._inputHandler.bind(this);
  }

  getInputElement() {
    if (!this._inputElement) {
      this._inputElement = this._element.querySelector(`[name="${PROMOCODE_INPUT_NAME}"]`);
    }

    return this._inputElement;
  }

  getInputParentElement() {
    if (!this._inputParentElement) {
      this._inputParentElement = this.getInputElement().parentElement;
    }

    return this._inputParentElement;
  }

  getButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`[type="submit"]`);
    }

    return this._buttonElement;
  }

  setValid() {
    this.reset();

    const element = this.getInputElement();
    element.classList.add(`${element.classList[0]}_applied`);

    const button = this.getButtonElement();
    button.classList.add(`${button.classList[0]}_applied`);

    this._defaultButtonText = button.textContent;
    button.textContent = APPLIED_TEXT;
  }

  setInvalid() {
    this.reset();

    const element = this.getInputElement();
    element.classList.add(`${element.classList[0]}_invalid`);
  }

  reset() {
    const element = this.getInputElement();
    element.classList.remove(`${element.classList[0]}_applied`);
    element.classList.remove(`${element.classList[0]}_invalid`);

    const button = this.getButtonElement();
    button.classList.remove(`${button.classList[0]}_applied`);

    if (this._defaultButtonText) {
      button.textContent = this._defaultButtonText;
    }
  }

  setSubmitHandler(callback) {
    this._callback.submit = callback;
    this._element.addEventListener(`submit`, this._submitHandler);
  }

  setInputHandler(callback) {
    this._callback.input = callback;
    this.getInputElement().addEventListener(`input`, this._inputHandler);
  }

  _submitHandler(evt) {
    this._callback.submit(evt);
  }

  _inputHandler() {
    this._callback.input();
  }
}
